import React from 'react';
import { useLocation } from 'react-router-dom';
import { employmentRequirements } from './data';
import { Circle } from 'lucide-react';
import MatchButton from './MatchButton';
import '../assests/CSS/EmploymentRequirements.css';

const EmploymentRequirements = () => {
  const location = useLocation();
  const searchData = location.state?.searchData || {};
  const selectedService = searchData.search || "EOR/PEO/AOR";
  const selectedCountry = searchData.location || "United States";

  const { title, image, points } = employmentRequirements.getRequirements(selectedService, selectedCountry);

  return (
    <div className="employment-container">
      <div className="employment-text">
        <h2>
          {title} — {selectedCountry} ({selectedService})
        </h2>
        {points.length > 0 ? (
          <ul>
            {points.map((point, index) => (
              <li key={index}>
                <span className="dot-icon"><Circle strokeWidth={4} color="#113157" /></span>
                <div className="point-content">
                  <span className="point-subtitle">{point.subtitle}</span>
                  <span className="point-text">{point.text}</span>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <div className="no-requirements">
            <p>No specific requirements found for {selectedService} in {selectedCountry}</p>
          </div>
        )}
        <MatchButton />
      </div>
      <div className="employment-image">
        <img 
          src={image} 
          alt={`${selectedCountry} employment`}
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = "/assets/images/placeholder.png";
          }}
        />
      </div>
    </div>
  );
};

export default EmploymentRequirements;
